import { BaSePopupButton, BaSeSmall1 } from '@base/react';
import React from 'react';
import { ContainerListManager, ContentListManager } from './table-style';

function ListCityRegionl({ listCities = [] }) {
  return (
    <>
      <ContainerListManager>
        <ContentListManager>
          {listCities
            .slice(0, listCities.length <= 3 ? listCities.length : 2)
            .map((c) => (
              <BaSeSmall1 color="#939393" key={c.name}>
                {c.name}
              </BaSeSmall1>
            ))}
          {listCities.length > 3 && (
            <BaSeSmall1 color="#939393">...</BaSeSmall1>
          )}
        </ContentListManager>

        {listCities.length > 3 && (
          <BaSePopupButton
            alertSize={150}
            name="exclamation-circle"
            direction="right"
            iconProps={{
              color: '#0000C9',
              name: 'exclamation-circle',
              size: 15,
            }}
            message={listCities.map((c, index) => {
              return (
                <BaSeSmall1 color="#939393" key={c.name}>
                  {c.name}
                </BaSeSmall1>
              );
            })}
            title="exclamation-circle"
          />
        )}
      </ContainerListManager>
    </>
  );
}

export default ListCityRegionl;
